const data = require("./data");
const whenAppStarted = require("./whenAppStarted");
const whenButtonsVideoPopupClosesStopVideo = require("./when/whenButtonsVideoPopupClosesStopVideo");
const jQuery = require("jquery");
const whenDocumentReady = require("./when/whenDocumentReady");

module.exports = function main() {
  jQuery(document).ready(async () => {
    await whenDocumentReady();
  });

  whenAppStarted(data);
  whenButtonsVideoPopupClosesStopVideo();
};
